module.exports = require('./head');



//////////////////
// WEBPACK FOOTER
// ./node_modules/lodash/first.js
// module id = 2456
// module chunks = 1